import { ChangeDetectorRef, Component, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { GlobalMessageService, GlobalMessageType } from '@spartacus/core';
import { DeviceDetectorService } from 'ngx-device-detector';
import { take } from 'rxjs';
import { CheckoutServiceExtends } from 'src/app/service/checkout/checkout.service';
import { ComponentService } from 'src/app/service/component.service';
import { ShimanoCountryService } from 'src/app/service/country/shimano-country.service';
import { CustomTranslationService } from 'src/app/service/language/custom-translation.service';
import { ShimanoLanguageService } from 'src/app/service/language/shimano-language.service';
import { MyAccountPermissionService } from 'src/app/service/myaccount/my-account-permission.service';
import { OrderDetailsService } from 'src/app/service/myaccount/order-details.service';
import { PaymentService } from 'src/app/service/payment/payment.service';
import { OrderDetailsInvoiceComponent } from '../order-details-invoice/order-details-invoice.component';

@Component({
  selector: 'app-snappay-order-details-invoice',
  templateUrl: './snappay-order-details-invoice.component.html',
  styleUrl: './snappay-order-details-invoice.component.scss',
  standalone: false,
})
export class SnappayOrderDetailsInvoiceComponent extends OrderDetailsInvoiceComponent implements OnInit, OnDestroy {
  globalMsg = document.querySelector('cx-global-message');
  constructor(
    protected orderDetailsService: OrderDetailsService,
    private paymentService: PaymentService,
    private globalMessageService: GlobalMessageService,
    private renderer: Renderer2,
    componentService: ComponentService,
    deviceService: DeviceDetectorService,
    cdr: ChangeDetectorRef,
    checkoutServiceExtends: CheckoutServiceExtends,
    countryService: ShimanoCountryService,
    languageService: ShimanoLanguageService,
    customTranslationService: CustomTranslationService,
    myAccountPermissionService: MyAccountPermissionService
  ) {
    super(
      orderDetailsService,
      componentService,
      deviceService,
      cdr,
      checkoutServiceExtends,
      countryService,
      languageService,
      customTranslationService,
      myAccountPermissionService
    );
  }

  viewAndPayInvoices() {
    this.paymentService
      .redirectToSnappayInvoice()
      .pipe(take(1))
      .subscribe({
        next: (invoiceData) => {},
        error: (err) => {
          this.paymentService.fullPageOverlaySpinner('hide');
          setTimeout(() => {
            if (this.globalMsg) {
              this.renderer.addClass(this.globalMsg, 'showCxGlobalMessage');
              this.globalMessageService.add({ key: 'error.snappaySsoToken' }, GlobalMessageType.MSG_TYPE_ERROR);
            }
          });
        },
      });
  }
}
